import React, {useEffect, useState} from "react";
import {Form, Modal} from "react-bootstrap";
import {useFormik} from "formik";
import {apiGenericCreate, apiGenericUpdate, genericGetOne} from "../generic/crud";
import {ENTITY_ID_VEHICLE_MODEL} from "../generic/Constants";
import {defaultVehicleModel} from "../generic/InitialStates";
import {showToast, TOAST_SUCCESS} from "../../utils/toast/Toast";
import {AGCText} from "../../generic-components/AGCText";
import {AGCStaticSelect} from "../../generic-components/AGCStaticSelect";
import {OEM_LIST} from "../generic/OEMList";
import {VEHICLE_SEGMENT_LIST} from "../generic/VehicleSegmentList";


export function VehicleModelAddEditDialog(props) {
    const {show, handleClose, id} = props;
    const [forUpdate, setForUpdate] = useState(false);
    const [objectForSubmit, setObjectForSubmit] = useState(defaultVehicleModel);
    const [isLoading, setIsLoading] = useState(false);
    const [title, setTitle] = useState("Vehicle Model");
    const entityName = "Vehicle Model";

    const formik = useFormik({
        initialValues: objectForSubmit,
        enableReinitialize: true,
        onSubmit(vehicleModel, {resetForm}) {
            setIsLoading(true);

            // Convert OEM object to just the ID string
            if (vehicleModel.oem && vehicleModel.oem.id) {
                vehicleModel.oem = vehicleModel.oem.id;
            }

            // Convert vehicleSegment object to just the ID string
            if (vehicleModel.vehicleSegment && vehicleModel.vehicleSegment.id) {
                vehicleModel.vehicleSegment = vehicleModel.vehicleSegment.id;
            }

            if (!id) {
                apiGenericCreate(ENTITY_ID_VEHICLE_MODEL, vehicleModel).then(() => {
                    setIsLoading(false);
                    handleClose(true);
                    showToast(entityName + " is Created!", TOAST_SUCCESS);
                    resetForm();
                }).catch(() => {
                    setIsLoading(false);
                });
            } else {
                apiGenericUpdate(ENTITY_ID_VEHICLE_MODEL, vehicleModel, id).then(() => {
                    setIsLoading(false);
                    handleClose(true);
                    showToast(entityName + " is Updated!", TOAST_SUCCESS);
                    resetForm();
                }).catch(() => {
                    setIsLoading(false);
                });
            }
        }
    });

    useEffect(() => {
        if (id != null) {
            setForUpdate(true);
            setTitle("Edit " + entityName);
            setIsLoading(true);

            genericGetOne(ENTITY_ID_VEHICLE_MODEL, id).then(
                ({data}) => {
                    // Convert OEM string to object for AGCStaticSelect
                    if (data.oem) {
                        const oemObj = OEM_LIST.find(oem => oem.id === data.oem);
                        data.oem = oemObj || {id: data.oem, name: data.oem};
                    }

                    // Convert vehicleSegment string to object for AGCStaticSelect
                    if (data.vehicleSegment) {
                        const segmentObj = VEHICLE_SEGMENT_LIST.find(segment => segment.id === data.vehicleSegment);
                        data.vehicleSegment = segmentObj || {id: data.vehicleSegment, name: data.vehicleSegment};
                    }

                    setObjectForSubmit(data);
                    setTitle("Update " + entityName);
                    setIsLoading(false);
                })
                .catch(() => {
                    setIsLoading(false);
                });
        } else {
            setForUpdate(false);
            setObjectForSubmit(defaultVehicleModel);
            setTitle("New " + entityName);
        }
    }, [show]);


    return (
        <Modal
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            aria-labelledby="example-modal-sizes-title-lg">
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="overlay">
                {!isLoading && (
                    <Form className="form form-label-right">
                        <div className="form-group row">

                            <Form.Group className="col-lg-12">
                                <AGCStaticSelect
                                    formik={formik}
                                    isMulti={false}
                                    id={'oem'}
                                    name={"Select OEM"}
                                    data={OEM_LIST}
                                    value={formik.values.oem}
                                    toolTip={"Please select the OEM (Original Equipment Manufacturer)"}/>
                            </Form.Group>

                            <Form.Group className="col-lg-12">
                                <AGCText formik={formik}
                                         name={"Model"}
                                         placeHolder={'Enter Model'}
                                         id={"model"}
                                         toolTip={"Please enter the Vehicle Model"}
                                         value={formik.values.model}/>
                            </Form.Group>

                            <Form.Group className="col-lg-12">
                                <AGCStaticSelect
                                    formik={formik}
                                    isMulti={false}
                                    id={'vehicleSegment'}
                                    name={"Vehicle Segment"}
                                    data={VEHICLE_SEGMENT_LIST}
                                    value={formik.values.vehicleSegment}
                                    toolTip={"Please select the Vehicle Segment"}/>
                            </Form.Group>
                        </div>

                        <br/>
                        <Modal.Footer>
                            <div>
                                <button
                                    type="button"
                                    className="btn btn-light btn-elevate"
                                    onClick={handleClose}>
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    onClick={formik.handleSubmit}
                                    className="btn btn-primary btn-elevate">
                                    Save
                                </button>
                            </div>
                        </Modal.Footer>
                    </Form>
                )}
                {isLoading && <span>Please Wait, Fetching Information from Server</span>}
            </Modal.Body>
        </Modal>
    );
}
